/*
 const portalUrl = await getPortalLink();
      Linking.openURL(portalUrl.data.url);
      */

//import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { parse } from '../../../parse';
import { collection, doc, setDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../../../../firebase';
import {
  keyRemovedAction,
  keyUpdatedAction
} from '../../../../redux/actions/local';
import useCloud from '../../../cloud';
import { useLocation } from 'react-router-dom';
import { getStepFieldValue } from '../utils';
import _ from 'lodash';

const useStripe = () => {
  const user = useSelector(state => state.User);
  const { dataLinks } = useSelector(state => state.DataLinks);
  const dispatch = useDispatch();
  const { callFunction } = useCloud();

  const location = useLocation();

  const stripeCheckoutSessionOTP = async ({
    page,
    sequence,
    step,
    data = {},
    documents,
    selections,
    local,
    history
  }) => {
    const userId = parse({
      markup: step.stripeUserId,
      documents,
      selections,
      actionSequenceExecutionHistory: history,
      local,
      user,
      data,
      dataLinks
    });

    const userEmail = parse({
      markup: step.stripeUserEmail,
      documents,
      selections,
      actionSequenceExecutionHistory: history,
      local,
      user,
      data,
      dataLinks
    });

    let currencyCode = step.stripeCurrency;

    if (currencyCode?.indexOf('{') > -1) {
      currencyCode = parse({
        markup: currencyCode,
        documents,
        selections,
        actionSequenceExecutionHistory: history,
        local,
        user,
        data,
        dataLinks
      });
    }

    if (!currencyCode || currencyCode?.trim().length === 0) {
      const userLocale = navigator.language || navigator.userLanguage;
      if (userLocale === 'en-GB') {
        currencyCode = 'gbp';
      } else if (userLocale === 'en-US') {
        currencyCode = 'usd';
      } else {
        currencyCode = 'eur';
      }
    }

    const path = `stripe_customers/${userId}/checkout_sessions`;
    const newRef = doc(collection(db, path));

    const appendSessionIdAndEmail = url => {
      let returnUrl = url;
      if (url.indexOf('?') > -1) {
        returnUrl = `${url}&session_id={CHECKOUT_SESSION_ID}`;
      } else {
        returnUrl = `${url}?session_id={CHECKOUT_SESSION_ID}`;
      }

      if (userEmail && userEmail.indexOf('{') === -1) {
        if (returnUrl.indexOf('?') > -1) {
          returnUrl = `${returnUrl}&email=${userEmail}`;
        } else {
          returnUrl = `${returnUrl}?email=${userEmail}`;
        }
      }

      returnUrl = parse({
        markup: returnUrl,
        documents,
        selections,
        actionSequenceExecutionHistory: history,
        local,
        user,
        data,
        dataLinks
      });

      return returnUrl;
    };

    /*
    const newCheckoutSession = {
      client: 'mobile',
      mode: element.paymentType,
      payment_method_types: ['card'],
      capture_method:
        element.paymentType === 'preauth' ? 'manual' : 'automatic',
      currency: priceInformation.currency,
      amount: priceInformation.unit_amount,
      metadata: {
        userId: user.userId,
        appId: config.appId,
        documentId: document?.id,
        documentPath: getFirestorePath(),
        product: product.name,
        description: product.description
      }
    };
    */

    let lineItems = [];
    let lineItemsTest = [];
    let metadata = { userId };
    let metadataTest = { userId };

    if (!step.stripePriceIdStyle || step.stripePriceIdStyle === '') {
      lineItems = [
        {
          price: step.stripePriceId, // priceId is the amount,
          quantity: 1
        }
      ];
      lineItemsTest = [
        {
          price: step.stripePriceIdTest, // priceId is the amount,
          quantity: 1
        }
      ];
    } else {
      if (step.stripePriceIdStyle === 'multiple') {
        lineItems = JSON.parse(step.stripePriceIds);
        try {
          lineItemsTest = JSON.parse(step.stripePriceIdsTest);
        } catch {
          // na
        }
      } else if (step.stripePriceIdStyle === 'multiple_local') {
        lineItems = _.get(local, step.stripePriceIdLocalStoreKey);
        lineItemsTest = _.get(local, step.stripePriceIdLocalStoreKeyTest);
      } else if (step.stripePriceIdStyle === 'custom_line_items') {
        try {
          // eslint-disable-next-line
          const computeFunction = new Function(
            'page',
            'step',
            'sequence',
            'history',
            'selections',
            'documents',
            'local',
            'user',
            'data',
            step.stripeCustomLineItems
          );
          lineItems = computeFunction(
            page,
            step,
            sequence,
            history,
            selections,
            documents,
            local,
            user,
            data
          );
        } catch (error) {
          console.error(
            'stripeCheckoutSessionOTP custom_line_items function error: ',
            error.toString()
          );
          return { error };
        }

        try {
          // eslint-disable-next-line
          const computeFunction = new Function(
            'page',
            'step',
            'sequence',
            'history',
            'selections',
            'documents',
            'local',
            'user',
            'data',
            step.stripeCustomLineItemsTest
          );
          lineItemsTest = computeFunction(
            page,
            step,
            sequence,
            history,
            selections,
            documents,
            local,
            user,
            data
          );
        } catch (error) {
          console.error(
            'stripeCheckoutSessionOTP custom_line_items (test mode) function error: ',
            error.toString()
          );
          return { error };
        }
      }
    }

    if (step.stripeMetaData?.trim().length > 0) {
      try {
        // eslint-disable-next-line
        const computeFunction = new Function(
          'page',
          'step',
          'sequence',
          'history',
          'selections',
          'documents',
          'local',
          'user',
          'data',
          step.stripeMetaData
        );
        const functionResult = computeFunction(
          page,
          step,
          sequence,
          history,
          selections,
          documents,
          local,
          user,
          data
        );

        metadata = {
          ...metadata,
          ...functionResult
        };
      } catch (error) {
        return { error };
      }
    }

    if (step.stripeMetaDataTest?.trim().length > 0) {
      try {
        // eslint-disable-next-line
        const computeFunction = new Function(
          'page',
          'step',
          'sequence',
          'history',
          'selections',
          'documents',
          'local',
          'user',
          'data',
          step.stripeMetaDataTest
        );
        const functionResult = computeFunction(
          page,
          step,
          sequence,
          history,
          selections,
          documents,
          local,
          user,
          data
        );

        metadataTest = {
          ...metadataTest,
          ...functionResult
        };
      } catch (error) {
        return { error };
      }
    }

    const newCheckoutSession = {
      stripe_customerId: userId,
      id: newRef.id,
      client: step.stripePaymentType === 'preauth' ? 'web_preauth' : 'web',
      mode: step.stripePaymentType,
      automatic_tax: true,
      tax_id_collection: true, // Collect the customer's tax ID (important for B2B transactions)
      payment_method_types: ['card'],
      payment_intent_data: {
        capture_method:
          step.stripePaymentType === 'preauth' ? 'manual' : 'automatic',
        setup_future_usage: 'off_session'
      },
      currency: currencyCode,
      line_items: lineItems,
      line_items_test: lineItemsTest,
      userId: user?.userID || '',
      metadata,
      metadata_test: metadataTest,
      setup_future_usage: 'off_session',
      success_url: appendSessionIdAndEmail(
        `${window.location.origin}${step.stripeSuccessUrl}`
      ),
      cancel_url: appendSessionIdAndEmail(
        `${window.location.origin}${step.stripeCancelUrl}`
      )
    };

    await setDoc(doc(db, path, newRef.id), newCheckoutSession, {
      merge: true
    });

    // Set up a real-time listener for the document
    onSnapshot(
      doc(db, path, newCheckoutSession.id),
      doc => {
        if (doc.exists()) {
          dispatch(keyUpdatedAction('stripeCheckoutSession', doc.data()));
        } else {
          dispatch(keyRemovedAction('stripeCheckoutSession'));
        }
      },
      error => {
        console.error('Error getting document:', error);
      }
    );
  };

  const stripeChargeForUpsells = async ({
    page,
    sequence,
    step,
    data = {},
    documents,
    selections,
    local,
    history,
    params
  }) => {
    let itemsTest = [];
    let itemsLive = [];

    if (step.stripeUpsellUseLocalStoreItems) {
      itemsLive = _.get(local, step.stripeUpsellLocalStoreKeyName);
    } else {
      try {
        itemsLive = JSON.parse(step.stripeUpsellItems);
      } catch {
        return { error: 'cannot parse live upsell items' };
      }
      try {
        itemsTest = JSON.parse(step.stripeUpsellItemsTest);
      } catch {
        return { error: 'cannot parse test upsell items' };
      }
    }

    const searchParams = new URLSearchParams(location.search);

    let sessionId =
      step.stripeUpsellSessionId?.trim().length > 0
        ? step.stripeUpsellSessionId
        : local?.stripeUpsellSessionId
        ? local.stripeUpsellSessionId
        : searchParams.get('session_id');

    if (!sessionId) {
      return { error: 'no checkout session id provided' };
    }

    if (sessionId.indexOf('{') > -1) {
      sessionId = getStepFieldValue({
        stepField: { value: sessionId },
        underlyingField: { type: 'string' },
        selections,
        history,
        documents,
        user,
        local,
        dataLinks,
        params,
        data
      });
    }

    const result = await callFunction('stripe_upsell', {
      sessionId,
      itemsLive,
      itemsTest
    });
    return result.data;
  };

  return { stripeCheckoutSessionOTP, stripeChargeForUpsells };
};

export default useStripe;
